import { PLANS } from "./types";
import { axiosCallNest } from "../utills/axios";
import { getSimplifiedPlans } from "../utills/dashboard_functions";

// Plan actions
export const planActions = { getPlans };

// Get All Plans
export function getPlans(setLoading = true) {
  return async (dispatch) => {
    if (setLoading) dispatch({ type: PLANS.UPDATE, payload: { isLoading: true } });

    try {
      const { data } = await axiosCallNest("public/subscriptions/plans", "get");

      // Sort plans by free/paid/custom
      if (data?.plans && data?.plans?.length > 0) {
        data.plans = getSimplifiedPlans(data.plans.sort((a, b) => a?.fee_type - b?.fee_type));
      }

      dispatch({ type: PLANS.UPDATE, payload: { isLoading: false, ...data } });
    } catch (error) {
      const { status, data } = error.response || {};
      dispatch({ type: PLANS.UPDATE, payload: { isLoading: false, error: { status, message: data?.error } } });
    }
  };
}

export const resetState = () => (dispatch) => dispatch({ type: PLANS.RESET });
export const updateState = (payload) => (dispatch) => dispatch({ type: PLANS.UPDATE, payload });
